export const getEmailFromParam = (): string | undefined => {
  const query = new URLSearchParams(window.location.search)
  if (query.get('success') === 'true') {
    return query.get('email') || undefined
  }
  return undefined
}
